var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var MainHeading = /** @class */ (function (_super) {
    __extends(MainHeading, _super);
    function MainHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainHeading.prototype.render = function () {
        return (React.createElement("h3", { className: "rj-ev-list__main-heading " + ("rj-ev-list__main-heading--" + this.props.cardType.toLowerCase()), "data-uat": "h3-ev-list-main-heading" }, this.props.children));
    };
    return MainHeading;
}(React.PureComponent));
export { MainHeading };
//# sourceMappingURL=MainHeading.js.map